<app-page-detail   [crud]="service" [(model)]="model" [(form)]="form"  [reload]="reload" (costumEliminazione)="deleteWsz($event)">
  <div class="flex flex-column md:flex-row gap-3 w-full justify-content-around p-3">
    <div class="flex flex-column gap-3 w-12">
      <app-card title="Informazioni" *ngIf="detailLoaded">
        <div class="row flex">
          <div class="col-6"><app-text-field label="Nome : " [value]="dati?.nome"></app-text-field></div>
          <div class="col-6"><app-text-field label="Codice : " [value]="dati?.resourceTitle"></app-text-field></div>
        </div>
        <div class="row flex">
          <div class="col-6"><app-text-field label="Gestore : " [value]="getGestore()"></app-text-field></div>
          <div class="col-6"><app-text-field label="Data di Creazione : " [value]="formatDateCreation(dati?.dateOfCreation)"></app-text-field></div>
        </div>
     
<!--         <div card-form>
          <app-key-value-form [form]="form" keyField="codice" valueField="descrizione"></app-key-value-form>
        </div> -->
      
      </app-card>
      <div class="row flex">
        <div class="col-6">
        
      </div>
        <div class="col-6">
            <span style="color:red" *ngIf="checkOverlapMap">Sono presenti delle sovrapposizioni con altre Wsz</span> 
        </div>
      </div>
      <div class="row flex">
      <div class="col-6">

      <app-table *ngIf="dataPuntiCampionamento; else noParametriObb" matSort [data]="dataPuntiCampionamento" [columns]="columns" [visibleColumns]="visibleColumns" [rowClick]="customClickFunction.bind(this)" style="max-height: 50vh;overflow-y: scroll;">
        <ng-content></ng-content>
      </app-table>
      <ng-template #noParametriObb>
        Nessun Dato da Visualizzare
      </ng-template>
      </div>
      <div class="col-6">

       
    <app-editable-card  title="Wsz" [form]="form" [crud]="service" [modelId]="model()?.id" [(model)]="model" class="col-12 md:col-12 lg:col-12" [IsModifyClickable]="false"  [customActionClick]="customActionClick">
      <google-map 
        height="500px" 
        width="100%" 
        [center]="center" 
        [zoom]="zoom" 
        [options]="options">
      </google-map> 
      <div card-form>
        <google-map 
        height="500px" 
        width="100%" 
        [center]="center" 
        [zoom]="zoom" 
        [options]="options">
      </google-map> 
      </div>
    </app-editable-card>
      </div>
      </div>
    </div>
  </div>
</app-page-detail>

